import React from "react";
import Slider from "react-slick";
import Rcard from "./Testimonialprops";

import a from "./../../Assest/html.webp";
import b from "./../../Assest/css.webp";
import c from "./../../Assest/js.webp";
import i from "./../../Assest/bootstrap.webp";
import d from "./../../Assest/php.webp";
import e from "./../../Assest/react.webp";
import f from "./../../Assest/nodejs.webp";
import g from "./../../Assest/sql.webp";
import h from "./../../Assest/wordpress.webp";
import j from "./../../Assest/rest.webp";
import k from "./../../Assest/wooc.webp";
import L from "./../../Assest/python.webp";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import classes from "./Testimonials.module.css";
/*
import t1 from "./../../Assests/golde.png";
import t2 from "./../../Assests/siresj.png";
import t3 from "./../../Assests/dipika.png";
import t4 from "./../../Assests/p.png";

*/
const Testimonial = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 8000,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        cssEase: 'linear',
        responsive: [
            {
              breakpoint: 768,
              settings: {
                speed: 8000,
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                cssEase: 'linear',
                dots: false  
              }
            }
        ]
    };


    

    return (
<div> 

<div className={classes.rsl}>
      <br/><br/>
    <h1 className={classes.title}>WHAT WE DO</h1>
    <br/><br/>
<div className={classes.rsl2}>      
                <Slider {...settings}>

<div className={classes.titled}>
  <Rcard text="Medical Career Counselling" />
</div>

<div className={classes.titled}>
  <Rcard text="Application & Form Filling" />
</div>

<div className={classes.titled}>
  <Rcard text="Admission Guidance" />
</div>

<div className={classes.titled}>
  <Rcard text="College & Course Selection" />
</div>

<div className={classes.titled}>
  <Rcard text="NEET Counselling Support" />
</div>

<div className={classes.titled}>
  <Rcard text="Document Verification Assistance" />
</div>





                </Slider>
                </div>


       </div>     
   </div>    
    );
}

export default Testimonial;
